export default __webpack_public_path__ + "static/media/information--picnic-site--g1.6194592a.png";